export { RoomOption, type Props } from './index.pc'
export { MobileRoomOption } from './index.mobile'
